import { Component, Vue } from 'vue-property-decorator';
import { AchProviders } from '@/constants/payments';

@Component
export default class AchProvidersMixin extends Vue {
  get achProvider(): AchProviders {
    return this.$store.getters['PaymentOptions/achProvider'];
  }

  get isAchProviderCrb(): boolean {
    return this.achProvider === AchProviders.Crb;
  }
}
